module.exports = __webpack_public_path__ + "img/in_hub_logo.d0495d65.svg";